import React, { useEffect } from "react";
import { Alert } from "@sumprio/ui";
import { AUTO_DISMISS_ALERT_MS } from "constants/alert.constants";

export interface DetailPageAlertsProps {
  errorAlert: string | null;
  onClearError: () => void;
  successAlert: string | null;
  onClearSuccess: () => void;
  successDismissMs?: number;
  errorDismissMs?: number;
}

export default function DetailPageAlerts({
  errorAlert,
  onClearError,
  successAlert,
  onClearSuccess,
  successDismissMs = AUTO_DISMISS_ALERT_MS,
  errorDismissMs = AUTO_DISMISS_ALERT_MS,
}: DetailPageAlertsProps) {
  useEffect(() => {
    if (!errorAlert) return;
    const id = setTimeout(onClearError, errorDismissMs);
    return () => clearTimeout(id);
  }, [errorAlert, onClearError, errorDismissMs]);

  useEffect(() => {
    if (!successAlert) return;
    const id = setTimeout(onClearSuccess, successDismissMs);
    return () => clearTimeout(id);
  }, [successAlert, onClearSuccess, successDismissMs]);

  return (
    <>
      {errorAlert && (
        <Alert
          position="top-right"
          status="danger"
          title={errorAlert}
          showDescription={false}
          showCloseIcon={false}
        />
      )}
      {successAlert && (
        <Alert
          position="top-right"
          status="success"
          title={successAlert}
          showDescription={false}
          showCloseIcon={false}
        />
      )}
    </>
  );
}
